import React, { useState, useEffect, useRef, useCallback } from "react";
import { Tooltip } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import { NavLink } from "react-router-dom";
import TextFieldLg from "../../Components/common/TextField";
import CustomButton from "../../Components/common/Button";
import { checkedDevelopmentType, displayErrorMessages } from "../../Helpers";
import instance from "../../axios";
import { notifyError, notifySuccess } from "../../Utils";
import { useDispatch } from "react-redux";
import { callLoginFunction } from "./LoginComponent";
import Loader from "../../Layout/Loader";
import { themes } from "../../Reducers/Theme";
import InfoIcon from "./../../assets/monitoring/info.svg";

export default function OTPForm(props) {
  const { translate, switchView } = props
  const dispatch = useDispatch();
  const themecolors = themes[2];
  const OTP_EXPIRY = 300;

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [timer, setTimer] = useState(OTP_EXPIRY);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");
  const inputRefs = useRef([]);
const [startTime, setStartTime] = useState(() => {
  const saved = localStorage.getItem("otpStartTime");
  return saved ? parseInt(saved, 10) : Date.now();
});
  useEffect(() => {
    const tick = () => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const remaining = OTP_EXPIRY - elapsed;

      if (remaining <= 0) {
        setTimer(0);
        setIsResendDisabled(false);
        localStorage.removeItem("otpStartTime");
      } else {
        setTimer(remaining);
      }
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [startTime]);
  const handleChange = (e, index) => {
    const { value } = e.target;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text").trim();
    if (!/^\d+$/.test(pastedData)) return;

    const otpArray = pastedData.split("").slice(0, otp.length);
    setOtp([...otpArray, ...new Array(otp.length - otpArray.length).fill("")]);

    const lastIndex = otpArray.length - 1;
    if (lastIndex >= 0) inputRefs.current[lastIndex]?.focus();
  };

  const isOtpComplete = otp.every((digit) => digit !== "");
  const formatTime = (seconds) =>
    `${Math.floor(seconds / 60)}:${(seconds % 60).toString().padStart(2, "0")}`;
  const errorCallBack = (data) => {
    setLoading(false);
    setLoginErrorMessage(displayErrorMessages(data.message));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const fetchUrl = checkedDevelopmentType();
    const app = `3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05`;
    const otpValue = otp.join("");

    try {
      setLoading(true);
      const response = await instance.post(`/api/session/verify-otp`,
        new URLSearchParams({ otp: otpValue, app, host: fetchUrl })
      );

      callLoginFunction({
        props,
        dispatch,
        userInfoFront: response,
        setLoading,
        setLoginErrorMessage,
        errorCallBack,
      });
    } catch (error) {
     setLoading(false);

  const serverMsg = error?.message || error?.message;

  if (serverMsg?.toLowerCase().includes("invalid") || serverMsg?.toLowerCase().includes("expired")) {
    setLoginErrorMessage("Incorrect or Expired OTP");
      dispatch(notifyError("Incorrect or Expired OTP" || "Something went wrong"));
  } else {
      dispatch(notifyError(serverMsg || "Something went wrong"));
    setLoginErrorMessage(serverMsg || "Something went wrong");
  }


    }
  };
  const handleResend = useCallback(async () => {
    try {
      const fetchUrl = checkedDevelopmentType();
      const app = `3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05`;

      const response = await instance.post(`/api/session/resend-otp`,
        new URLSearchParams({ app, host: fetchUrl })
      );

      dispatch(notifySuccess(response || "OTP resent successfully"));
      setOtp(new Array(6).fill(""));
      const newStart = Date.now();
      setStartTime(newStart);
      localStorage.setItem("otpStartTime", newStart);

      setTimer(OTP_EXPIRY);
      setIsResendDisabled(true);
    } catch (error) {
      dispatch(notifyError(error?.message || "Resend OTP failed"));
    }
  }, [dispatch]);

  if (loading) {
    return (
      <div className="loginLoaderWrapper">
        <Loader />
      </div>
    );
  }

  return (
    <form className="loginForm" onSubmit={handleSubmit} autoComplete="off">
      <div className="login-logo-wrapper">
        <img className="login-logo" src={props.whiteLabling?.logo} alt="logo" />
      </div>
      {loginErrorMessage && (
        <div className="alert alert-danger" style={{ color: themecolors.error }}>
          <svg fill="currentColor" width={16} height={16}>
            <use xlinkHref={`${InfoIcon}#icon`} />
          </svg>
          {translate?.(loginErrorMessage)}
        </div>
      )}

      <p style={{ marginBottom: 10, fontSize: 12, color: themecolors?.textColor }}>
        Please enter the 6-digit OTP sent to your email.
      </p>
      <div style={{ display: "flex", justifyContent: "center", gap: 8, marginBottom: 10 }}>
        {otp.map((digit, i) => (
          <TextFieldLg
            key={i}
            type="text"
            value={digit}
            onChange={(e) => handleChange(e, i)}
            onKeyDown={(e) => handleKeyDown(e, i)}
            onPaste={handlePaste}
            inputRef={(el) => (inputRefs.current[i] = el)}
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                fontSize: 20,
                width: "30px",
                padding: "8px",
              },
            }}
          />
        ))}
      </div>
      <p style={{ textAlign: "center", marginTop: 0 }}>
        <CustomButton
          themecolors={themecolors}
          type="submit"
          className="btn-submit"
          variant="contained"
          disabled={!isOtpComplete}
        >
          Verify
        </CustomButton>
      </p>
      {isResendDisabled ? (
        <p style={{ textAlign: "center", fontSize: 12, color: themecolors?.textColor }}>
          Resend OTP in {formatTime(timer)}
        </p>
      ) : (
        <p
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            fontSize: 12,
          }}
        >
          <Tooltip title="Resend OTP">
            <ReplayIcon
              onClick={handleResend}
              className="actionButton"
              style={{ cursor: "pointer", color: themecolors?.textColor }}
            />
          </Tooltip>
          <span>Didn’t get OTP? Click to resend</span>
        </p>
      )}
      <p style={{ textAlign: "center" }}>
        <NavLink
          to="/login"
          onClick={() => switchView?.("login")}
          style={{ color: themecolors?.textColor }}
        >
          Back to Login
        </NavLink>
      </p>
      <div className="login-footer">
        <a href={props.whiteLabling?.termsLink}>{translate?.("about") || "About"}</a>
        <a href={props.whiteLabling?.termsLink}>
          {translate?.("termsAndConditions") || "Terms"}
        </a>
        <a href={props.whiteLabling?.privacyPolicyLink}>
          {translate?.("privacy") || "Privacy"}
        </a>
      </div>
    </form>
  );
}
